import Tokens from '@nokia-csf-uxr/freeform-design-tokens';
import styled, { css } from 'styled-components';
import { DEEP_BORDER_BOX } from 'common';

const MEDIUM_HEIGHT = '2rem';
const SMALL_HEIGHT = '1.25rem';

const MAX_WIDTH = '16rem';

const GET_BORDER = color => `0 0 0 0.125rem inset ${color}`;

const GET_BORDER_RADIUS =
  props => `border-radius: ${props.size === 'small' ? `calc(${SMALL_HEIGHT} / 2)` : `calc(${MEDIUM_HEIGHT} / 2)`};`;

const CHIP_STYLE = (props, theme) => css`
  background-color: ${(props.hovered && props.focused) ? theme.hoveredFocused.background :
    props.hovered ? theme.hovered.background :
      props.focused ? theme.focused.background :
        theme.background};
  & :after {
    content:'';
    display:block;
    box-shadow: ${(props.hovered && props.focused) ? GET_BORDER(theme.hoveredFocused.border) :
    props.hovered ? GET_BORDER(theme.hovered.border) :
      props.focused ? GET_BORDER(theme.focused.border) :
        GET_BORDER(theme.border)};
    ${GET_BORDER_RADIUS(props)}
    position:absolute;
    top:0;
    left:0;
    width:100%;
    height:100%;
  }
`;

const LABEL_STYLE = (props, theme) => css`
  color: ${(props.hovered && props.focused) ? theme.hoveredFocused.content :
    props.hovered ? theme.hovered.content :
      props.focused ? theme.focused.content :
        theme.content};
`;

const SEC_LABEL_STYLE = (props, theme) => css`
  color: ${(props.hovered && props.focused) ? theme.hoveredFocused.secondaryContent :
    props.hovered ? theme.hovered.secondaryContent :
      props.focused ? theme.focused.secondaryContent :
        theme.secondaryContent};
`;


const GENERIC_CHIP_STYLE = props => css`
  ${DEEP_BORDER_BOX}
  ${css`direction: ${(props.RTL || props.$rtl || props.rtl) ? 'rtl' : 'ltr'};`}
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  align-self: flex-start;
  flex: 0;
  height: ${props.size === 'small' ? SMALL_HEIGHT : MEDIUM_HEIGHT};
  ${GET_BORDER_RADIUS(props)}
  max-width: ${MAX_WIDTH};
  &:focus {
    outline: none
  }
`;

export default {
  Chip: styled.div`
    cursor: pointer;
    ${props => GENERIC_CHIP_STYLE(props)}
    ${props => CHIP_STYLE(props, props.$theme)};
  `,
  ChipLabel: styled.span`
    ${({ $isPressed }) => $isPressed && css`
      z-index: 1; // text above ripple for AAA contrast
    `}
    display: flex;
    flex-direction: ${props => props.stacked && props.$hasSecondaryLabel ? 'column' : 'row'};
    align-items: ${props => props.stacked && props.$hasSecondaryLabel ? 'flex-start' : 'center'};
    justify-content: flex-start;
    width: auto;
    height: ${props => props.size === 'small' ? SMALL_HEIGHT : MEDIUM_HEIGHT};
    overflow: hidden;
    padding-right: ${props => props.stacked ? Tokens.SPACING.SPACING_8 : Tokens.SPACING.SPACING_4};
    padding-left: ${props => props.stacked ? Tokens.SPACING.SPACING_8 : Tokens.SPACING.SPACING_0};
  `,
  Label: styled.span`
    user-select: none;
    ${props => props.size === 'small' || props.stacked ? css(Tokens.TYPOGRAPHY.CAPTION) : css(Tokens.TYPOGRAPHY.BODY)};
    line-height: initial;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
    padding-right: ${props => props.stacked ? '0' : Tokens.SPACING.SPACING_4};
    padding-left: ${props => props.stacked ? '0' : Tokens.SPACING.SPACING_8};
    color: ${props => props.infoChip ? props.$theme.content : 'inherit'};
    ${props => !props.infoChip && LABEL_STYLE(props, props.$theme.default)};
    ${props => (props.selected && !props.infoChip) ? LABEL_STYLE(props, props.$theme.selected) : css``};
    ${props => (props.error && !props.infoChip) ? LABEL_STYLE(props, props.$theme.error) : css``};
  `,
  SecondaryLabel: styled.span`
    ${props => props.size === 'small' || props.stacked ? css(Tokens.TYPOGRAPHY.CAPTION) : css(Tokens.TYPOGRAPHY.BODY)};
    line-height: initial;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
    padding-right: ${props => (props.RTL || props.$rtl || props.rtl) ? '0' : Tokens.SPACING.SPACING_4};
    padding-left: ${props => !(props.RTL || props.$rtl || props.rtl) ? '0' : Tokens.SPACING.SPACING_4};
    color: ${props => props.infoChip ? props.$theme.content : 'inherit'};
    ${props => !props.infoChip && SEC_LABEL_STYLE(props, props.$theme.default)};
    ${props => (props.selected && !props.infoChip) ? SEC_LABEL_STYLE(props, props.$theme.selected) : css``};
    ${props => (props.error && !props.infoChip) ? SEC_LABEL_STYLE(props, props.$theme.error) : css``};
  `,
  InfoChip: styled.div`
    ${props => GENERIC_CHIP_STYLE(props)};
    background: ${props => props.$theme.background};
    &:focus {
      box-shadow: 0 0 0 ${Tokens.SPACING.SPACING_2} inset ${props => props.$theme.focused.border};
    }
  `,
};